import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vdd-text-readonly',
  templateUrl: './vdd-text-readonly.component.html',
  styleUrls: ['./vdd-text-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddTextReadonlyComponent {
  @Input() value: string;
  @Input() label: string;
  @Input() isDescription: boolean;

  constructor() {}
}
